import { X } from 'lucide-react';
import { Button } from '../ui/button/Button';

export interface ActiveFilter {
    key: string;
    /** Shown on the chip, e.g. "Type: Welcome letter". */
    label: string;
    onRemove: () => void;
}

interface ActiveFilterChipsProps {
    filters: ActiveFilter[];
    onClearAll: () => void;
}

export function ActiveFilterChips({ filters, onClearAll }: ActiveFilterChipsProps) {
    if (filters.length === 0) return null;

    return (
        <ul aria-label="Active filters" className="flex flex-wrap items-center gap-2">
            {filters.map((filter) => (
                <li
                    key={filter.key}
                    className="inline-flex items-center gap-1 rounded-full bg-mp-primary-content py-1 pl-3 pr-1.5 text-xs font-medium text-mp-link"
                >
                    {filter.label}
                    <button
                        type="button"
                        aria-label={`Remove filter ${filter.label}`}
                        onClick={filter.onRemove}
                        className="rounded-full p-0.5 hover:bg-mp-border focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-mp-primary"
                    >
                        <X aria-hidden="true" className="size-3.5" />
                    </button>
                </li>
            ))}
            <li>
                <Button type="button" size="xs" variant="neutral" appearance="ghost" onClick={onClearAll}>
                    Clear all
                </Button>
            </li>
        </ul>
    );
}
